<template>
  <div class="guide-container">
    <iframe
      :src="guideSrc"
      class="guide-iframe"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'GuideView',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  computed: {
    guideSrc() {
      return this.src
    }
  }
}
</script>

<style scoped>
.guide-container {
  width: 100%;
  height: calc(100vh - 64px);
  overflow: hidden;
}

.guide-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
